import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase";
import { Navigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';

function ProtectedRoute({ children, allowedRoles }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [loggedIn, setLoggedIn] = useState(true);

  const auth = getAuth();
  const db = getFirestore(app);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setLoggedIn(false);
        setLoading(false);
        return;
      }

      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        setAuthorized(false);
      } else {
        const userType = userDoc.data().userType;
        setAuthorized(allowedRoles.includes(userType));
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, db, allowedRoles]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spinner animation="border" />
      </div>
    );
  }

  if (!loggedIn) {
    return <Navigate to="/login" />;
  }

  if (!authorized) {
    return <Navigate to={allowedRoles.includes("An Influencer") ? "/user/dashboard" : "/dashboard"} />;
  }

  return children;
}

export default ProtectedRoute;